module.exports = {
        srcSet: __webpack_public_path__ + "destination_host_penny-149-08dead2455eab62e.digested.png"+" 149w",
        images: [{path: __webpack_public_path__ + "destination_host_penny-149-08dead2455eab62e.digested.png",width: 149,height: 48}],
        src: __webpack_public_path__ + "destination_host_penny-149-08dead2455eab62e.digested.png",
        toString: function(){return __webpack_public_path__ + "destination_host_penny-149-08dead2455eab62e.digested.png"},
        
        width: 149,
        height: 48
      }